<template>
    <modal @close="editSecuritySettingsCancelClick" class="edit-modal" hideFooter id="edit-security-settings">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Security Settings</h3>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Security Settings</h3>
                    <div class="md-col-2">
                        <div class="column">

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Account Administrator
                                    <input name="isAdmin" type="checkbox" v-model="updateModel.isAdmin" :checked="updateModel.isAdmin" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Allow Ratings
                                    <input name="allowRatings" type="checkbox" v-model="updateModel.allowRatings" :checked="updateModel.allowRatings === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Edit Notes
                                    <input name="editNotes" type="checkbox" v-model="updateModel.editNotes" :checked="updateModel.editNotes === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Manage Service Network
                                    <input name="addFavoriteAvoid" type="checkbox" v-model="updateModel.addFavoriteAvoid" :checked="updateModel.addFavoriteAvoid === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Advanced Preferences
                                    <input name="advancedPreferences" type="checkbox" v-model="updateModel.advancedPreferences" :checked="updateModel.advancedPreferences === true" />
                                    <span></span>
                                </label>
                            </div>

                        </div>
                        <div class="column">

                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="editSecuritySettingsCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="editSecuritySettingsSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditSecuritySettings';
    export default script;
</script>
<style lang="less">
    @import './EditSecuritySettings.less';
</style>